import React from "react";
import img1 from "../assets/manufacture1.webp";
import img2 from "../assets/manufacture2.webp";
import img3 from "../assets/manufacture3.jpg";
import img4 from "../assets/manufacture4.jpg";
import { Container, Row, Col, Card } from "react-bootstrap";
import {
  FaChartLine,
  FaHandHoldingUsd,
  FaBalanceScale,
  FaTrophy,
} from "react-icons/fa";
import AnimatedCarousel from "../component/animatedcarousel/animatedcarousel";

const Manufacturing = () => {
  const slides = [
    {
      img: img1,
      title: "Smart Manufacturing Solutions",
      subtitle: "Delivering Efficiency, Precision & Transparency",
    },
    {
      img: img2,
      title: "Smart Manufacturing Solutions",
      subtitle: "Delivering Efficiency, Precision & Transparency",
    },
    {
      img: img3,
      title: "Smart Manufacturing Solutions",
      subtitle: "Delivering Efficiency, Precision & Transparency",
    },
  ];

  const highlights = [
    {
      icon: <FaChartLine size={40} />,
      title: "Robust Demand",
      description:
        "During FY25 (Until December 2024), India’s merchandise exports reached Rs. 27,94,695 crore (US$ 321.71 billion), up from Rs. 27,50,739 crore (US$ 316.65 billion) in the previous fiscal. By 2030, the Indian middle class is expected to have the second-largest share in global consumption at 17%",
      image: img4,
    },
    {
      icon: <FaHandHoldingUsd size={40} />,
      title: "Increasing Investment",
      description:
        "India's domestic investment announcements surged to Rs. 37 lakh crore (US$ 428.04 billion) in FY23-FY24 from Rs. 10 lakh crore (US$ 115.69 billion) in FY21, with 9M FY25 already reaching Rs. 32 lakh crore (US$ 370.20 billion). FDI in India's manufacturing sector has reached Rs. 14,45,781 crore (US$ 165.1 billion), a 69% increase over the past decade, driven by production-linked incentive (PLI) schemes. In the last five years, total FDI inflows amounted to Rs. 33,58,310 crore (US$ 383.5 billion)",
      image: img2,
    },
    {
      icon: <FaBalanceScale size={40} />,
      title: "Policy Support",
      description:
        "The government has introduced the Drone Promotion and Utilisation Policy 2025, aiming to boost drone manufacturing and its application across various sectors. The policy offers incentives, of a 40% capital investment subsidy, up to Rs. 30 crore (US$ 3.4 million) for new investments, and a 25% subsidy on lease rents for three years",
      image: img3,
    },
    {
      icon: <FaTrophy size={40} />,
      title: "Competitive Advantage",
      description:
        "The positive developments in the manufacturing sector, driven by production capacity expansion, government policy support, heightened M&A activity, and PE/VC-led investment, are creating a robust pipeline for the country’s sustained economic growth in the years to come.",
      image: img4,
    },
  ];

  return (
    <>
      <div style={{ overflow: "hidden" }}>
        <AnimatedCarousel slides={slides} />
        <section className="manufacturing-highlights py-5 bg-light">
          <Container>
            <h2 className="text-center mb-4 fw-bold">
              Why India's Manufacturing Sector is Booming
            </h2>
            <Row>
              {highlights.map((item, index) => (
                <Col key={index} xs={12} className="mb-4" data-aos="fade-down">
                  <Card className="shadow highlight-card overflow-hidden">
                    <Row className=" align-items-center">
                      <Col xs={12} md={9} className="p-4">
                        <div className="mb-3 theme-font-color">{item.icon}</div>
                        <h5 className="fw-bold">{item.title}</h5>
                        <p>{item.description}</p>
                      </Col>
                      <Col xs={12} md={3}>
                        <img
                          src={item.image}
                          alt={item.title}
                          className="img-fluid w-100 h-100 object-fit-cover"
                        />
                      </Col>
                    </Row>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      </div>
    </>
  );
};

export default Manufacturing;
